import gql from 'graphql-tag'

export default gql`
  mutation popups_create_mutation(
    $title: String!
    $isActive: Boolean!
    $body: String!
    $buttonUrl: String!
    $buttonText: String!
  ) {
    popupCreate(
      title: $title
      isActive: $isActive
      body: $body
      buttonUrl: $buttonUrl
      buttonText: $buttonText
    ) {
      id
    }
  }
`
